import React, { useEffect, useState } from "react";
import fetchData from "../../../api/fetchApi";
import { useParams, useNavigate } from "react-router-dom";
import PageHeader from "../../common/PageHeader";
import Table from "../../common/Table";

export default function ResellerDetailPage() {
  const { id } = useParams();
  const [reseller, setReseller] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [usersError, setUsersError] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);
  const [filter, setFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetchData(`finance/resellers/${id}`)
      .then(data => setReseller(data.data))
      .catch(err => setError(err.message || "حدث خطأ أثناء جلب البيانات"))
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    setUsersLoading(true);
    setUsersError(null);
    let url = `finance/resellers/${id}/reseller-users?page=${page}&page_size=${pageSize}`;
    if (filter) {
      url += `&search=${encodeURIComponent(filter)}`;
    }
    fetchData(url)
      .then(data => {
        setUsers(data.data || []);
        setTotalUsers(data.total || (data.meta && data.meta.total) || 0);
      })
      .catch(err => setUsersError(err.message || "حدث خطأ أثناء جلب المستخدمين"))
      .finally(() => setUsersLoading(false));
  }, [id, page, pageSize, filter]);

  if (loading) return <div className="text-center mt-8">جاري التحميل...</div>;
  if (error) return <div className="text-red-600 text-center mt-8">{error}</div>;
  if (!reseller) return null;

  const userColumns = [
    { header: "المعرف", accessor: "id" },
    { header: "الاسم", accessor: "name" },
    { header: "البريد الإلكتروني", accessor: "email" },
    { header: "الهاتف", accessor: "phone" },
    { header: "نشط؟", accessor: "is_active", render: row => row.is_active ? "نعم" : "لا" },
    { header: "تاريخ الإنشاء", accessor: "created_at" },
  ];

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir="rtl">
      <PageHeader title={`تفاصيل الموزع: ${reseller.name}`} total={0} stats={[]} />
      <div className="bg-gray-50 rounded-xl p-6 shadow mt-6">
        <div className="mb-2"><b>المعرف:</b> {reseller.id}</div>
        <div className="mb-2"><b>الاسم:</b> {reseller.name}</div>
        <div className="mb-2"><b>البريد الإلكتروني:</b> {reseller.email}</div>
        <div className="mb-2"><b>الهاتف:</b> {reseller.phone}</div>
        <div className="mb-2"><b>العنوان:</b> {reseller.address || '-'} </div>
        <div className="mb-2"><b>نشط؟</b> {reseller.is_active ? "نعم" : "لا"}</div>
        <div className="mb-2"><b>موزع؟</b> {reseller.is_reseller ? "نعم" : "لا"}</div>
        <div className="mb-2"><b>نسبة العمولة:</b> {reseller.commissions_rate}</div>
        <div className="mb-2"><b>تاريخ الإنشاء:</b> {reseller.created_at}</div>
        <div className="mb-2"><b>تاريخ التحديث:</b> {reseller.updated_at}</div>
      </div>
      <div className="flex gap-2 justify-end mt-6">
        <button className="bg-gray-200 px-4 py-2 rounded" onClick={() => navigate(-1)}>رجوع</button>
        <button className="bg-yellow-500 text-white px-4 py-2 rounded" onClick={() => navigate(`/finance/resellers/${reseller.id}/edit`)}>تعديل</button>
      </div>

      <div className="mt-10">
        <h2 className="text-xl font-bold mb-4">مستخدمو الموزع</h2>
    
        {usersLoading && <div className="text-center mt-4">جاري تحميل المستخدمين...</div>}
        {usersError && <div className="text-red-600 text-center mt-4">{usersError}</div>}
        <Table columns={userColumns} rows={users}  pagination={{
            title: "الموزعون",
            label: `الصفحة ${currentPage} من ${totalPages}`,
            pages: Array.from({ length: totalPages }, (_, i) => i + 1),
            current: currentPage,
            last: totalPages,
            onPageChange: setCurrentPage,
            perPage: pageSize,
            onPerPageChange: setPageSize,
          }} />
      </div>
       
       
    </div>
  );
}
